import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { UserService } from '../port/user.service';
import { User } from '../entity/user.interface';
import { environment } from '@env/environment';

@Injectable()
export class UserBackendService implements UserService {
  readonly #http = inject(HttpClient);
  readonly #baseUrl = 'http://localhost:3000';


  fetch(userId: string, bearerToken: string): Observable<User> {
    const headers = { 'Authorization': `Bearer ${bearerToken}` };
    // Utiliser /users/me qui récupère l'utilisateur basé sur le JWT
    return this.#http.get<User>(`${this.#baseUrl}/users/me`, { headers }).pipe(
      catchError((error) => {
        if (error.status === 404) {
          return throwError(() => new Error('User not found'));
        }
        return throwError(() => new Error('Error fetching user data'));
      })
    );
  }

  create(user: User, bearerToken: string): Observable<void> {
    const headers = { 'Authorization': `Bearer ${bearerToken}` };
    return this.#http.post<void>(`${this.#baseUrl}/users`, user, { headers }).pipe(
      catchError((error) => {
        return throwError(() => new Error('Error creating user'));
      })
    );
  }
}